import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const ArrowLeft = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="vuesax/outline/arrow-left">
        <g id="arrow-left">
          <path
            id="Vector"
            d="M6.38094 12.5466C6.25427 12.5466 6.1276 12.5 6.0276 12.4L1.98094 8.35329C1.7876 8.15996 1.7876 7.83996 1.98094 7.64662L6.0276 3.59996C6.22094 3.40662 6.54094 3.40662 6.73427 3.59996C6.9276 3.79329 6.9276 4.11329 6.73427 4.30662L3.04094 7.99996L6.73427 11.6933C6.9276 11.8866 6.9276 12.2066 6.73427 12.4C6.64094 12.5 6.5076 12.5466 6.38094 12.5466Z"
          />
          <g id="Vector_2">
            <mask id="path-2-inside-1_3025_207">
              <path d="M13.6692 8.5H2.44922C2.17589 8.5 1.94922 8.27333 1.94922 8C1.94922 7.72667 2.17589 7.5 2.44922 7.5H13.6692C13.9426 7.5 14.1692 7.72667 14.1692 8C14.1692 8.27333 13.9426 8.5 13.6692 8.5Z" />
            </mask>
            <path d="M13.6692 8.5H2.44922C2.17589 8.5 1.94922 8.27333 1.94922 8C1.94922 7.72667 2.17589 7.5 2.44922 7.5H13.6692C13.9426 7.5 14.1692 7.72667 14.1692 8C14.1692 8.27333 13.9426 8.5 13.6692 8.5Z" />
            <path
              d="M13.6692 7.5H2.44922V9.5H13.6692V7.5ZM2.44922 7.5C2.72817 7.5 2.94922 7.72105 2.94922 8H0.949219C0.949219 8.82562 1.6236 9.5 2.44922 9.5V7.5ZM2.94922 8C2.94922 8.27895 2.72817 8.5 2.44922 8.5V6.5C1.6236 6.5 0.949219 7.17438 0.949219 8H2.94922ZM2.44922 8.5H13.6692V6.5H2.44922V8.5ZM13.6692 8.5C13.3903 8.5 13.1692 8.27895 13.1692 8H15.1692C15.1692 7.17438 14.4948 6.5 13.6692 6.5V8.5ZM13.1692 8C13.1692 7.72105 13.3903 7.5 13.6692 7.5V9.5C14.4948 9.5 15.1692 8.82562 15.1692 8H13.1692Z"
              mask="url(#path-2-inside-1_3025_207)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

ArrowLeft.displayName = 'ArrowLeft';
